import React, { FC } from 'react'
import { useInmateCounts } from '../hooks'


const InmateCount: FC = () => {
  const counts = useInmateCounts()

  if (!counts) {
    return null
  }

  return (
    <div style={{ marginTop: '5px', marginBottom: '15px' }}>
      <div className="span4">
        <i className="icon-user"></i> Male - {counts.male}
      </div>
      <div className="span4">
        <i className="icon-user"></i> Female - {counts.female}
      </div>
      <div className="span4">
        <i className="icon-plus-sign"></i> Total - {counts.total}
      </div>
    </div>
  )
}

export default InmateCount